import React, { useMemo } from 'react'
import { useTheme } from '@ui-kitten/components'
import ReactContentLoader, { IContentLoaderProps } from 'react-content-loader/native'

export { Rect, Circle } from 'react-content-loader/native'

export type ContentLoaderProps = IContentLoaderProps & {
  variant?: 'default' | 'card'
}

export const ContentLoader = ({ variant = 'default', ...props }: ContentLoaderProps) => {
  const theme = useTheme()

  const gradientProps = useMemo(() => {
    if (variant === 'card') {
      return {
        backgroundColor: theme['theme.surface.base1'],
        foregroundColor: theme['theme.surface.base'],
      }
    }

    return {
      backgroundColor: theme['theme.surface.base2'],
      foregroundColor: theme['theme.surface.base1'],
    }
  }, [variant, theme])

  return <ReactContentLoader {...gradientProps} {...props} />
}
